import React from 'react';
import { NavLink } from 'react-router-dom';

const NavigationItem = props => {
    return (
        <li className={props.className}>
            <NavLink to={{ pathname: props.pathName }} exact activeClassName="active"><span>{props.title}</span></NavLink>
        </li>
    );
}

export default NavigationItem;